import { get } from 'lodash-es';

/**
 * Return tracking data dealer_distance
 * @param leadTargets
 * @returns {Array} rounded to one decimal place ['0.12', '7.5', '10.5']
 */
export function getDealerDistanceList(leadTargets) {
  return leadTargets.map(({ leadAttributes: { distance } }) => {
    const distanceParsed = parseFloat(distance);
    return isNaN(distanceParsed) ? '' : distanceParsed.toFixed(1);
  });
}

/**
 * Return tracking data inventory_lead_yes_no
 * @param leadTargets [inventory, inventory, dealer, dealer]
 * @returns {Array} [true, true, false, false]
 */

export function getInventoryLeadYesNoList(leadTargets) {
  return leadTargets.map(({ inventory }) => inventory !== undefined);
}

/**
 * Return tracking data inventory_lead_yes_no after lead form is submitted
 * @param leadTargets [inventory, inventory, dealer, dealer]
 * @param positions [1, 3]
 * @returns {Array} [null, true, null, fale]
 */
export function getInventoryLeadYesNoListByPositions(leadTargets, positions) {
  return leadTargets.map(({ inventory }, index) => (positions.includes(index) ? inventory !== undefined : null));
}

/**
 * Return tracking data style_id
 * @param leadTargets [inventory, inventory, dealer, dealer]
 * @returns {Array} [1234, 5678, 0, 0]
 */
export function getStyleIdList(leadTargets) {
  return leadTargets.map(({ inventory }) => get(inventory, 'vehicleInfo.styleInfo.styleId', 0));
}

/**
 * Return tracking data style_id after lead form is submitted
 * @param leadTargets [inventory, inventory, dealer, dealer]
 * @param positions [0, 2]
 * @returns {Array} [1234, null, 0, null]
 */
export function getStyleIdListByPositions(leadTargets, positions) {
  return leadTargets.map(({ inventory }, index) =>
    positions.includes(index) ? get(inventory, 'vehicleInfo.styleInfo.styleId', 0) : null
  );
}

/**
 * Return tracking data lead_uuid after lead form is submitted
 * @param leadTargets [inventory, inventory, inventory]
 * @param positions [0, 2]
 * @param leadIds ['uid-3432423', 'uid-45345345']
 * @returns {Array} ['uid-3432423', null, 'uid-45345345']
 */
export function getLeadIdListByPositions(leadTargets, positions, leadIds) {
  return leadTargets.map((target, index) => leadIds[positions.indexOf(index)] || null);
}
